import axios from '../plugins/axios'
const state = {
  log_modal : false,
  o_id : null,
  loading : false,
  form_errors : [],
  log_list_modal : false,
  log_list_loading : false,
  log_items : [],
  log_types : []
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {
  getLogTypes({commit}){
    axios.get('get_log_types')
    .then(function(res){
      commit('setLogData',{
        key : 'log_types',
        value : res.data.data
      })
    })
  },
  addLog({commit,getters},data) {
    var formData = new FormData();
    formData.append('type',getters.getDataByKey('type'))
    formData.append('o_id',getters.getDataByKey('o_id'))
    for(var key in data){
      formData.append(key,data[key])
    }
    commit('setLogData',{key : 'loading',value : true})
    commit('setLogData',{key : 'form_errors',value : []})
    axios.post('logs/add',formData)
    .then(function(res){
      let data = res.data
      if(!data.status){
        commit('setLogData',{key : 'form_errors',value : data.errors})
      }
      if(data.status){
        commit('setLogData',{key : 'log_modal',value : false})
        commit('setLogData',{key : 'type',value : null})
        commit('setLogData',{key : 'o_id',value : null})
        commit('setLogData',{key : 'form_errors',value : []})
      }
    }).catch(function(){

    })
    .then(function(){
      commit('setLogData',{key : 'loading',value : false})
    })
  },
  getlogs({commit,getters},data){
    commit('setLogData',{key : 'log_list_loading',value : true})
    let type = getters.getDataByKey('type')
    let o_id = getters.getDataByKey('o_id')
    axios.get('document/list?type='+type+'&o_id='+o_id+'&'+data)
    .then(function(res){
      let data = res.data
      commit('setLogData',{key : 'log_items',value : data.data})
    })
    .then(function(){
      commit('setLogData',{key : 'log_list_loading',value : false})
    })
  }

}
const mutations = {
  setLogData(state,data){
    state[data.key] = data.value
  },
  setLogModal(state,data){
    state.log_modal = data
    if(!data){
      state.file_errors = []
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}